var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from './button.styles';
import LoadingSpinner from '../loading-spinner/loading-spinner';
import { classNames } from '../../utils/style-class.utils';
import { renderIcon } from '../../utils/icon-utils';
import { Typography } from '..';
export var Button = function (_a) {
    var id = _a.id, type = _a.type, shape = _a.shape, disabled = _a.disabled, _b = _a.background, background = _b === void 0 ? 'filled' : _b, color = _a.color, _c = _a.size, size = _c === void 0 ? 'normal' : _c, isLoading = _a.isLoading, onClick = _a.onClick, children = _a.children, className = _a.className, testId = _a.testId, icon = _a.icon, _d = _a.iconPosition, iconPosition = _d === void 0 ? 'start' : _d, text = _a.text, textColor = _a.textColor, style = _a.style, _e = _a.buttonType, buttonType = _e === void 0 ? 'button' : _e;
    return (_jsxs("button", __assign({ style: style, id: id, "data-testid": testId, type: buttonType, className: classNames(styles.getButtonClassName(type, disabled !== null && disabled !== void 0 ? disabled : false, color, shape !== null && shape !== void 0 ? shape : 'normal', size, background), className), disabled: disabled, onClick: onClick }, { children: [isLoading && (_jsx(LoadingSpinner, { size: "small", spinnerColor: "white", backgroundColor: "uiMid" })), icon &&
                iconPosition === 'start' &&
                renderIcon(icon, "h-5 w-4 mr-2 text-".concat(textColor)), text && _jsx(Typography, { type: 'button', color: textColor, text: text }), icon &&
                iconPosition === 'end' &&
                renderIcon(icon, "h-5 w-4 ml-2 text-".concat(textColor)), children] })));
};
export default Button;
//# sourceMappingURL=button.js.map